const constants = {
    serverUrl: "https://api.party46project.syndevo.ru"
    // serverUrl: "http://localhost:3001"
}

export default constants